<template lang="pug">
  #freights.storekeepers-freight.right-panel.md-elevation-1.md-scrollbar.md-theme-default
    .entity-card
      .md-layout-row.entity-card-head
        .md-layout-item.entity-head-left
          span(v-if="freight && freight.traking_number") {{ '№ ' + freight.traking_number }}
        .md-layout-item.entity-head-center
          .md-caption.debt(v-if="freight && freight.id")
              .allow(v-if="canIssue") Выдача разрешена
              .deny(v-else) Выдача запрещена
        .md-layout-item.entity-head-right
          md-button.md-primary.md-icon-button.md-dense.close.small(v-if="canChangeFreight && (canAcceptFreights || $route.params.id != 'new')" v-on:click="save()" v-bind:disabled="loading")
            md-icon check
            md-tooltip(md-direction="bottom" md-delay="500") Сохранить
          md-button.md-icon-button.md-dense.close.small(v-bind:to="{name: 'StorekeepersFreights'}" v-bind:disabled="loading")
            md-icon close
            md-tooltip(md-direction="bottom" md-delay="500") Отменить
      .entity-card-body(v-loader-overlay="progress")
        z-input(
          v-if="freight && freight.status"
          name="freight_status"
          id="freight_status"
          label="Статус груза"
          v-model="freight.status.name"
          v-bind:error="errors.first('freight_status')"
          disabled
          readonly
        )
        
        z-input(
          v-if="!form.deal_id"
          name="seats_number" 
          id="seats_number" 
          label="Количество мест" 
          type="number"
          v-bind:min="1"
          v-bind:max="999"
          v-model="form.seats_number" 
          v-bind:disabled="loading || $route.params.id !== 'new'"
          v-bind:readonly="loading || $route.params.id !== 'new'"
          data-vv-as=" "
          v-validate="'required|min_value:1|max_value:999'"
          v-bind:error="errors.first('seats_number')"
        )

        .md-layout.delivery(v-if="($route.params.id === 'new')")
          .md-layout-item.md-alignment-top-left.md-size-50
            z-select(
              label="Способ доставки груза" id="delivery_method_to" name="delivery_method_to"
              v-model="form.delivery_method_to" v-bind:required="true"
              v-validate="{'required': true}" v-bind:error="errors.first('delivery_method_to')"
              data-vv-name="delivery_method_to" v-bind:data-vv-as="' '"
            )
              option(v-bind:value="1") До терминала
              option(v-bind:value="2") До адреса клиента
              
          .md-layout-item.md-alignment-top-right.md-size-50(v-if="form.delivery_method_to && parseInt(form.delivery_method_to) === 1")
            z-select(
                label="Склад" id="to_stock" name="to_stock"
                v-model="form.to_stock_id"
                v-bind:required="true" v-validate="{'required': true}"
                v-bind:error="errors.first('to_stock')" data-vv-name="to_stock" v-bind:data-vv-as="' '"
            )
              option(v-for="stock in allStocks" v-bind:value="stock.id" v-bind:key="stock.id") {{ stock.name }}


          .md-layout-item.md-alignment-top-right.md-size-50(v-if="form.delivery_method_to && parseInt(form.delivery_method_to) === 2")
            ZInputAutocomplete(
              label="Введите точный адрес" display-property="unrestricted_value" property="unrestricted_value" return="unrestricted_value"
              v-model="form.to_address.address" v-bind:showOnFocus="true"
              v-bind:callback="suggestAddress"
              v-bind:default="form.to_address.address"
              v-on:select="selectAddress" v-on:clear="clearAddress"
              id="to_address" name="to_address" data-vv-name="from_address" v-bind:required="true"
              v-bind:data-vv-as="' '" v-validate="{'required': true}" v-bind:error="errors.first('from_address')"
            )
          // 
          //ZInputAutocomplete(
            v-if="($route.params.id === 'new')"

            label="Город назначения" id="to_city_id" name="to_city_id"
            display-property="name" property="id"i

            v-model="form.to_city_id"
            v-bind:callback="getCities"

            data-vv-as=" " data-vv-name="to_city_id" v-bind:data-vv-as="' '"
            v-bind:error="errors.first('to_city_id')"
            v-bind:required="true"
            v-validate="'required|numeric'"
            v-bind:disabled="loading"
            )

        md-field(v-bind:class="{ 'md-invalid': errors.has('executor_company_id') }" v-if="companies && !form.executor_company_id")
          label Исполнитель
          md-select(v-model="form.executor_company_id" v-bind:disabled="loading || $route.params.id !== 'new' || !canChangeFreight" id="executor_company_id" name="executor_company_id" v-validate="'required|numeric'" data-vv-as=" ")
            md-option(v-for="item in companies" v-bind:key="item.id" v-bind:value="item.id" v-bind:disabled="parseInt(item.active) == 0") {{ ((parseInt(item.nds)) ? `с НДС ${item.nds_value}%` : 'без НДС') + ' (' + item.name + ')'}}
          span.md-error(v-show="errors.has('executor_company_id')") {{ errors.first('executor_company_id') }}
        
        md-field(v-bind:class="{ 'md-invalid': errors.has('from_stock_id') }" v-if="stocks && stocks.length > 1")
          label Склад отправления
          md-select(v-model="form.from_stock_id" v-bind:disabled="loading || $route.params.id != 'new' || !canChangeFreight" id="from_stock_id" name="from_stock_id" v-validate="'required|numeric'" data-vv-as=" ")
            md-option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{stock.name}}
          span.md-error(v-show="errors.has('from_stock_id')") {{ errors.first('from_stock_id') }}

        md-field(v-bind:class="{ 'md-invalid': errors.has('status_id') }" v-if="statuses && statuses.length > 1")
          label Статус заявки
          md-select(v-model="form.status_id" v-bind:disabled="loading || $route.params.id != 'new' || !canChangeFreight" id="status_id" name="status_id" v-validate="'required|numeric'" data-vv-as=" ")
            md-option(v-for="status in statuses" v-bind:key="status.id" v-bind:value="status.id") {{status.name}}
          span.md-error(v-show="errors.has('status_id')") {{ errors.first('status_id') }}

        md-field(v-bind:class="{ 'md-invalid': errors.has('freight_status_id') }" v-if="freightsStatuses && freightsStatuses.length > 2")
          label Статус груза
          md-select(v-model="form.freight_status_id" v-bind:disabled="loading || $route.params.id != 'new' || !canChangeFreight" id="freight_status_id" name="freight_status_id" v-validate="'required|numeric'" data-vv-as=" ")
            md-option(v-for="status in freightsStatuses" v-bind:key="status.id" v-bind:value="status.id") {{status.name}}
          span.md-error(v-show="errors.has('freight_status_id')") {{ errors.first('freight_status_id') }}


        .md-layout.delivery
          .md-layout-item.md-alignment-top-left.md-size-50
            z-input(
              v-if="!form.deal_id" v-model="form.sender_comment"
              name="sender_comment" id="sender_comment" label="Отправитель (Наименование/ФИО/ИНН/Паспорт)"
              v-validate="'min:0|max:255'" data-vv-name="sender_comment" v-bind:data-vv-as="' '" v-bind:error="errors.first('sender_comment')"
            )
          .md-layout-item.md-alignment-top-left.md-size-50
            z-input(
              v-if="!form.deal_id" v-model="form.recipient_comment"
              name="recipient_comment" id="recipient_comment" label="Получатель (Наименование/ФИО/ИНН/Паспорт)"
              v-validate="'min:0|max:255'" data-vv-name="recipient_comment" v-bind:data-vv-as="' '" v-bind:error="errors.first('recipient_comment')"
            )

        md-field(v-if="!form.deal_id" v-bind:class="{ 'md-invalid': errors.has('freight_description') }")
          label Комментарий кладовщика
          md-textarea(v-model="form.storekeeper_comment" name="storekeeper_comment")
          span.md-error(v-show="errors.has('storekeeper_comment')") {{ errors.first('storekeeper_comment') }}

        .button-container(v-if="!blockDeal")
          md-button.md-primary(v-on:click="onCaptureBtn()" v-if="freight && freight.deal_id && storeFreight && parseFloat(storeFreight.size) > 0 && parseFloat(storeFreight.weight) > 0 && storeFreight.status") Подписать
          md-button.cart-head-item.md-accent(
            v-if="(freight && freight.id && $route.params.id != 'new' && deal && deal.recipient_id && canIssue)"
            v-on:click="issue"
          ) Выдать груз

        .shipment.md-caption(v-if="blockDeal")
          .deny Груз выдан клиенту, изменение заявки заблокированно. Выдача невозможна.
        toggle-card(v-show="freight && freight.id && $route.params.id != 'new'" class="freight-card"  v-bind:visibility="(showFreight && freight && freight.id) ? true : false" v-bind:heading="'Данные груза ' + freight.traking_number")
          freight-card(
            v-on:reload="init"
            v-model="freight"
            v-bind:index="freight.id"
            v-bind:hideLink="true"
            v-bind:statuses="freightsStatuses"
            v-bind:block="blockDeal || !canChangeFreight"
            ref="freightCard"
            v-bind:recipient_id="(freight.deal && freight.deal && freight.deal.recipient_id) ? parseInt(freight.deal.recipient_id) : 0"
          )
        toggle-card(v-bind:visibility="true" heading="Услуги груза")
          services(form="storekeeper" v-bind:freight="freight" ref="packageservices")

        toggle-card(v-if="freight && freight.deal && freight.deal.id && freight.deal.recipient_id" class="recipient-card" v-bind:visibility="showRecipient" heading="Данные получателя")
            recipient(ref="recipient" v-bind:id="parseInt(freight.deal.recipient_id)" v-bind:deal_id="parseInt(freight.deal.id)")

        toggle-card(v-if="freight && freight.deal_id && freight.deal_id != 'new' && user && user.id" class="comments-card" v-bind:visibility="showComments" heading="Комментарии кладовщика")
          comments-and-logs(
              v-bind:entity_id="parseInt(freight.deal_id)"
              entity="deals"
              module="deals"
              v-bind:only_comments="true"
              v-bind:user_id="user.id"
              placeholder="Добавить новый комментарий"
          )

        .md-layout.md-gutter
            .md-layout-item.md-size-50
                md-field(v-show="freight.from_stock_signature" v-bind:class="{ 'md-invalid': errors.has('from_stock_signature'), 'md-has-value': !!freight.from_stock_signature }")
                    label Подпись отправителя на складе
                    wacom-signature(ref="signature" v-model="freight.from_stock_signature" v-on:capture-complete="onCapture" v-on:capture-cancel="onCaptureCancel")
            .md-layout-item.md-size-50
              md-field(v-if="freight && freight.id" v-show="freight.to_signature" v-bind:class="{ 'md-invalid': errors.has('to_signature'), 'md-has-value': !!freight.to_signature }")
                  label Подпись получателя
                  wacom-signature(ref="toSignature" v-model="freight.to_signature" v-on:capture-complete="onCaptureTo" v-on:capture-cancel="onCaptureCancelTo")

      .entity-card-footer
        ticket-print(
          v-show="!isLoading && freight && freight.id"
          ref="TicketsPrint"
          v-bind:data-callback="getPrintTicketData"
          v-bind:printers="printers"
          v-bind:trackingNumber="ticketsPrintData.trackingNumber"
          v-bind:date="ticketsPrintData.date"
          v-bind:fromCity="ticketsPrintData.fromCity"
          v-bind:toCity="ticketsPrintData.toCity"
          v-bind:fromAddress="ticketsPrintData.fromAddress"
          v-bind:toAddress="ticketsPrintData.toAddress"
          v-bind:recipient="ticketsPrintData.recipient"
          v-bind:sender="ticketsPrintData.sender"
          v-bind:seatsNumber="parseInt(ticketsPrintData.seatsNumber)"
          v-bind:temperature-regime="ticketsPrintData.tempReg"
        )
        .print-btn(v-on:click="printDoc(freight.deal_id, 'stock_note')" v-if="freight && freight.deal_id") Складская записка
</template>
<script>
    import ZebraPrinterManager from "@/assets/js/print/ZebraPrinterManager.js";
    import moment from "moment";
    import SortTable from "@/components/SortTable";
    import autocomplete from '@/components/autocomplete'
    import FreightCard from './FreightCard';
    import ToggleCard from '@/components/ToggleCard';
    import WacomSignature from '@/components/WacomSignature';
    import FlexTabs from '@/components/FlexTabs'
    import CommentsAndLogs from '@/components/CommentsAndLogs'
    import recipient from './forms/recipient.vue';
    import StockTicketsPrint from '@/components/StockTicketsPrint';
    import TicketPrint from '@/components/TicketPrint';
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    import Services from '@/components/Services';
    export default {
        components: {
            SortTable,
            autocomplete,
            FreightCard,
            ToggleCard,
            WacomSignature,
            FlexTabs,
            CommentsAndLogs,
            recipient,
            ZebraPrinterManager,
            StockTicketsPrint,
            ZInput,
            ZSelect,
            TicketPrint,
            ZInputAutocomplete,
            Services
        },
        metaInfo() {
            return {title: 'Груз'}
        },
        data() {
            return {
                title: 'Груз',
                loading: false,
                activeTab: 'tab-main',
                showComments: false,
                showRecipient: false,
                showFreight: true,
                alreadyPrint: false,
                canAcceptFreights: true,
                issueStatus: {},
                payersServices: {},
                tabs: [
                  {name: "tab-main",  label: "Груз"},
                  {name: "tab-print", label: "Дополнительно"}
                ],
                ticketsPrintData: {
                  //поля для старой логики
                  freight_tracking: '',
                  deal_tracking: '',
                  created_at: '',
                  from_city: '',
                  to_city: '',
                  seats_number: '',

                  //поля для новой логики
                  trackingNumber: '',
                  date:  '',
                  fromCity:  '',
                  toCity: '',
                  fromAddress: '',
                  toAddress: '',
                  seatsNumber: 0,
                  sender: '',
                  recipient: '',
                  tempReg: false,
                },
                form: {
                    id: null,
                    seats_number: null,
                    from_stock_id: null,
                    from_city_id: null,
                    to_city_id: null,
                    to_stock_id: null,
                    to_address_id: null,
                    to_address: {
                      id: null,
                      address: null,
                      type_id: 1,
                    },
                    delivery_method_to: 1,
                    status_id: null,
                    responsible_id: null,
                    deal_id: null,
                    freight_status_id: null,
                    executor_company_id: null,
                    payment_method_id: 2,
                    from_city: '',
                    to_city: '',
                    storekeeper_comment: null,
                    sender_comment: null,
                    recipient_comment: null,
                    full_oversize: 0,
                    height: 0,
                    length: 0,
                    width: 0,
                    oversize_width: 0,
                    oversize_height: 0,
                    oversize_length: 0,
                },
                form_default: {
                    id: null,
                    seats_number: null,
                    from_stock_id: null,
                    from_city_id: null,
                    to_city_id: null,
                    to_stock_id: null,
                    to_address_id: null,
                    to_address: {
                      id: null,
                      address: null,
                      type_id: 1,
                    },
                    delivery_method_to: 1,
                    status_id: null,
                    responsible_id: null,
                    deal_id: null,
                    freight_status_id: null,
                    executor_company_id: null,
                    payment_method_id: 2,
                    from_city: '',
                    to_city: '',
                    storekeeper_comment: null,
                    sender_comment: null,
                    recipient_comment: null,
                    full_oversize: 0,
                    height: 0,
                    length: 0,
                    width: 0,
                    oversize_width: 0,
                    oversize_height: 0,
                    oversize_length: 0,
                },
                address_default: {
                  id: null,
                  address: null,
                  type_id: 1,
                },
                deal: {},
                freight: {
                  full_oversize: 0
                },
                extraservicesDefault: {
                    doom_make: {
                        label: 'Изготовление обрешётки',
                        value: {
                            payer_id: null,
                            payer_hid: null,
                            value: false
                        }
                    }
                },                
            }
        },
        watch: {
            '$route.params.id'() {
                this.init();
            },
            '$route.path'() {
              this.$store.commit('adaptiveSizePanel');
              this.$store.commit('openRightPanel');
            },
            'companies'() {
              this.$nextTick(() => this.setDefaultExecutor());
            },
            'freightsStatuses'() {
                this.$nextTick(() => {
                  this.setDefaultTrackingStatus();
                  this.setDefaultIssueStatus();
                });
            },
            'storeFreight'(storeFreight) {
                this.$nextTick(() => {
                    this.canAcceptFreights = true;
                    this.freight = Object.assign({}, storeFreight);
                    //if (!this.freight.extraservices) this.freight.extraservices = Object.assign({}, this.extraservicesDefault);

                    this.ticketsPrintData.fromAddress = null;
                    this.ticketsPrintData.toAddress   = null;
                    this.ticketsPrintData.seatsNumber = 0;
                    this.ticketsPrintData.tempReg     = (storeFreight) ? this.HasTempReg(storeFreight) : false;

                    if (storeFreight && storeFreight.deal && storeFreight.deal.from_address && storeFreight.deal.from_address.address) this.ticketsPrintData.fromAddress = storeFreight.deal.from_address.address;
                    if (storeFreight && storeFreight.deal && storeFreight.deal.to_address && storeFreight.deal.to_address.address)     this.ticketsPrintData.toAddress   = storeFreight.deal.to_address.address;
                    if (storeFreight && storeFreight.seats_number) this.ticketsPrintData.seatsNumber = parseInt(storeFreight.seats_number);

                    if (storeFreight && storeFreight.deal && storeFreight.deal.delivery_method_from) this.$set(this.form, 'delivery_method_from', parseInt(storeFreight.deal.delivery_method_from));
                    if (storeFreight && storeFreight.deal && storeFreight.deal.delivery_method_to)   this.$set(this.form, 'delivery_method_to',   parseInt(storeFreight.deal.delivery_method_to));

                    if (storeFreight && storeFreight.deal && storeFreight.deal.to_city_id) this.$set(this.form, 'to_city_id',   parseInt(storeFreight.deal.to_city_id));
                    if (storeFreight && storeFreight.deal && storeFreight.deal.to_stock && storeFreight.deal.to_stock.city_id) {
                      this.$set(this.form, 'to_city_id',  parseInt(storeFreight.deal.to_stock.city_id));
                      this.$set(this.form, 'to_stock_id', parseInt(storeFreight.deal.to_stock_id));
                    }
                    if (storeFreight && storeFreight.deal && storeFreight.deal.to_address && storeFreight.deal.to_address.city_id) {
                      this.$set(this.form, 'to_city_id',   parseInt(storeFreight.deal.to_address.city_id));
                      this.$set(this.form, 'to_address',   storeFreight.deal.to_address);
                    }

                    if (storeFreight && storeFreight.deal && storeFreight.deal.from_city_id) this.$set(this.form, 'from_city_id', parseInt(storeFreight.deal.from_city_id));
                    if (storeFreight && storeFreight.deal && storeFreight.deal.from_stock && storeFreight.deal.from_stock.city_id) {
                      this.$set(this.form, 'from_city_id',   parseInt(storeFreight.deal.from_stock.city_id));
                      this.$set(this.form, 'from_stock_id',   parseInt(storeFreight.deal.from_stock));
                    }
                    if (storeFreight && storeFreight.deal && storeFreight.deal.from_address && storeFreight.deal.from_address.city_id) {
                      this.$set(this.form, 'from_city_id',   parseInt(storeFreight.deal.from_address.city_id));
                      this.$set(this.form, 'from_address',   storeFreight.deal.from_address);
                    }

                    if (storeFreight && storeFreight.deal && storeFreight.deal.from_stock_id) this.$set(this.form, 'from_stock_id', parseInt(storeFreight.deal.from_stock_id));
                    if (storeFreight && storeFreight.deal && storeFreight.deal.status_id)     this.$set(this.form, 'status_id', parseInt(storeFreight.deal.status_id));
                    if (storeFreight && storeFreight.deal && storeFreight.deal.executor_company_id) this.$set(this.form, 'executor_company_id', parseInt(storeFreight.deal.executor_company_id));
                    if (storeFreight && storeFreight.deal && storeFreight.deal.id) this.$set(this.form, 'deal_id', parseInt(storeFreight.deal.id));
                    if (storeFreight && storeFreight.status_id)    this.$set(this.form, 'freight_status_id', parseInt(storeFreight.status_id));
                    if (storeFreight && storeFreight.seats_number) this.$set(this.form, 'seats_number', parseInt(storeFreight.seats_number));
                    if (storeFreight && storeFreight.deal) this.$set(this.form, 'payer_id', parseInt(storeFreight.deal.payer_id));

                    if (storeFreight && storeFreight.deal && storeFreight.deal.sender    && storeFreight.deal.sender.name)    this.$set(this.form, 'sender_comment', storeFreight.deal.sender.name);
                    if (storeFreight && storeFreight.deal && storeFreight.deal.recipient && storeFreight.deal.recipient.name) this.$set(this.form, 'recipient_comment', storeFreight.deal.recipient.name);

                    if (storeFreight && parseInt(storeFreight.oversize) == 0) {
                      this.$set(this.form, 'oversize', null);
                      this.$set(this.freight, 'oversize', null);
                    }

                    if (storeFreight && parseInt(storeFreight.full_oversize) == 0) {
                      this.$set(this.form, 'full_oversize', null);
                      this.$set(this.freight, 'full_oversize', null);
                    }
                    
                    if (storeFreight && parseInt(storeFreight.doom) == 0) {
                      this.$set(this.form, 'doom', null);
                      this.$set(this.freight, 'doom', null);
                    }

                    //if (this.user && this.user.id) this.$set(this.form, 'responsible_id', parseInt(this.user.id));
                    if (parseFloat(this.freight.weight) <= 0) this.freight.weight = null;
                    if (parseFloat(this.freight.size) <= 0)   this.freight.size = null;

                    if (storeFreight && storeFreight.deal) this.deal = Object.assign({}, storeFreight.deal);

                    this.preparePayerServices(this.payersServices);
                    this.checkPrintTickets();
                });
            },
            'form.to_stock_id'(id) {
              let currentToStock = this.allStocks.find(stock => parseInt(stock.id) === parseInt(id));
              if (currentToStock && currentToStock.id && currentToStock.city_id) this.form.to_city_id = parseInt(currentToStock.city_id);
            },
            'form.from_city_id'(id) {
              this.getPrintCity();
            },
            'form.to_city_id'(id) {
              this.getPrintCity();
            },
            'form.delivery_method_to'(method) {
              this.form.to_city_id = null;
              if (parseInt(method) === 1) this.clearAddress();
              else if (parseInt(method) === 2) this.clearStock();
            }
        },
        computed: {
            user() {
                return this.$store.state.users.current;
            },
            endpoint() {
                return this.$store.state.endpoint;
            },
            storeFreight() {
                return this.$store.state.storekeepers_stocks.freight;
            },
            allStocks() {
                return this.$store.state.stock.stocks;
            },
            stocks() {
                return this.$store.state.storekeepers_stocks.stocks;
            },
            printers() {
              if (!this.stocks || !this.stocks.length) return [];
              let printers = [];
              this.stocks.map(stock => printers = printers.concat(stock.printers));
              return printers;
            },
            logged() {
                return this.$store.state.users.logedIn;
            },
            statuses() {
                return this.$store.state.storekeepers_stocks.deals_statuses;
            },
            freightsStatuses() {
                let freightsStatuses = this.$store.state.storekeepers_stocks.freight_statuses;
                return (freightsStatuses) ? freightsStatuses : [];
            },
            companies() {
              return this.$store.state.companies.companies;
            },
            progress() {
                return this.progressObj['load-storekeeper-freight-card'];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            isLoading() {
              return (this.progress || (this.$refs.freightCard && !!this.$refs.freightCard.progressFreight));
            },
            isDealComplete() {
              if (!this.freight || !this.freight.currenttracking || !this.freight.currenttracking.status) return false;
              if (parseInt(this.freight.currenttracking.status.tracking_type) == 6) return true;
              return false;
            },
            blockDeal() {
              return this.isDealComplete;
            },
            canChangeFreight() {
              if (this.blockDeal) return false;
              //Если трекинга ещё нет, значит идёт приём груза и можно изменять его данные
              if (!this.freight || !this.freight.currenttracking || !this.freight.currenttracking) return true;
              if (this.freight.currenttracking.status && this.freight.currenttracking.status.code) {
                //Если груз статус груза "Принят у клиента экспедитором" или "Принят у клиента кладовщиком", то он может менять данные груза, если статус другой, то не может.
                if (this.freight.currenttracking.status.code != 'storekeeper_accepted_from_client' && this.freight.currenttracking.status.code != 'forwarder_accepted_from_client') return false;
              }

              return true;
            },
            addressTypes() {
              return this.$store.state.address.address_types;
            },
            paymentMethods() {
                return this.$store.state.cost.payment_methods;
            },
            canIssue() {
                if (
                    !this.freight || !this.deal || parseInt(this.deal.status_issue_id) !== 1 ||
                    (this.freight.issuedtracking && this.freight.issuedtracking.id)
                ) return false;

                return true;
            },            
        },
        methods: {
            /**
             * Отдельный метод для вызова нужен чтобы Sentry корректно отлавливала ошибку
             */
            onCaptureBtn() {
              this.capture().catch(() => alert('Ошибка подписи'));
            },
            capture() {
              this.$off('onCapture');
              this.$off('onCaptureCancel');
              return new Promise((resolve, reject) => {
                this.$refs.signature.$emit('capture');
                this.$once('onCapture', () => resolve());
                this.$once('onCaptureCancel', () => {
                  if (reject) reject()
                });
              });
            },
            onCaptureCancel() {
              this.$emit('onCaptureCancel');
              this.$off('onCapture');
              this.$off('onCaptureCancel');
            },
            onCapture() {
              this.$emit('onCapture');
              this.loading = true;
              this.$nextTick(() => {
                //если это новый груз, то надо только подписать, обновлять не надо
                //if (this.form.id && this.freight && this.freight.id)
                  //this.updateFreight(true);
                  let data = {
                      //freight_id: this.freight.id,
                      //type: 'to_signature',
                      //signature: this.freight.to_signature,
                      deal_id: this.freight.deal_id,
                      type: 'from_stock_signature',
                      signature: this.freight.from_stock_signature,
                      signature_all_freight: true
                  };
                  this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                  return this.$store.dispatch('deals/setDealCapture', data).finally(() => {
                      this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card');
                  });

                  this.$off('onCapture');
                  this.$off('onCaptureCancel');
              });
            },
            captureTo() {
              this.$off('onCaptureTo');
              this.$off('onCaptureCancelTo');
              return new Promise((resolve, reject) => {
                this.$refs.toSignature.$emit('capture');
                this.$once('onCaptureTo', () => {
                  resolve();
                });
                this.$once('onCaptureCancelTo', () => {
                  if (reject) reject();
                });
              });
            },
            onCaptureCancelTo() {
              this.$emit('onCaptureCancelTo');
              this.$off('onCaptureTo');
              this.$off('onCaptureCancelTo');
            },
            onCaptureTo() {
              this.$nextTick(() => {
                this.doCaptureTo().then(() => {
                  this.$emit('onCaptureTo');
                  this.$off('onCaptureTo');
                  this.$off('onCaptureCancelTo');
                });
              });
            },
            doCaptureTo() {
                /*
                let data = {
                  freight_id: this.freight.id,
                  type: 'to_signature',
                  signature: this.freight.to_signature,
                };
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('deals/setDealFreightCapture', data).finally(() => {
                  this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card');
                });
                */
                let data = {
                    //freight_id: this.freight.id,
                    //type: 'to_signature',
                    //signature: this.freight.to_signature,
                    deal_id: this.freight.deal_id,
                    type: 'to_signature',
                    signature: this.freight.to_signature,
                    signature_all_freight: true
                };
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('deals/setDealCapture', data).finally(() => {
                    this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card');
                });
            },
            issue() {
              if (!this.canIssue) return this.$store.commit('showSnackbar', ['Груз запрешён к выдаче', 6000, 'error']);
              this.captureTo().then(() => {
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                let form = {
                  freight_id:     this.freight.id,
                  stock_id:       (this.freight && this.freight.currenttracking) ? this.freight.currenttracking.stock_id : null,
                  responsible_id: this.user.id,
                  status_id:      (this.issueStatus) ? this.issueStatus.id : 0,
                  date:           moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                };
                return this.$store.dispatch('stock/addFreightTracking', form).then(r => {
                  if (r) {
                    this.$store.commit('showSnackbar', ['Груз успешно выдан получателю', 6000, 'success']);
                    //Задача CRML-687 - сказали убрать автоматическую печать экспедиторской расписки
                    //this.printDoc(this.freight.deal_id, 'assignment');
                    this.init();
                    this.$root.$emit('reload-table', 'storekeepers-freights-table');
                  }
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
              }, () => alert('Ошибка подписи'));
            },
            print(routeData) {
              if (!routeData.query) routeData.query = {};
              routeData.query.freight_id = this.form.id;
              let route = this.$router.resolve(routeData);
              let url = route.href;
              window.open(url, '_blank', 'height=720,width=1280');
            },
            printDoc(id, type) {
                let url = this.endpoint + '/print/' + type + '?deal_id=' + id + '&user_id=' + this.user.id
                window.open(url, '_blank');
            },
            async printTicket() {
              this.ticketsPrintData = {
                  freight_tracking: this.freight.traking_number,
                  deal_tracking: this.freight.deal.traking_number,
                  created_at: this.freight.created_at,
                  from_city: this.form.from_city,
                  to_city: this.form.to_city,
                  seats_number: this.freight.seats_number,
                  from: 1,
                  to: this.freight.seats_number,
                  recipient: '',
                  sender: '',
              };
              if (!this.ticketsPrintData.from_city) {
                let city = await this.getCity(this.form.from_city_id).catch(() => '');
                if (city && city.name) this.ticketsPrintData.from_city = city.name;
                else this.ticketsPrintData.from_city = '';
              }

              if (!this.ticketsPrintData.to_city) {
                let city = await this.getCity(this.form.to_city_id).catch(() => '');
                if (city && city.name) this.ticketsPrintData.to_city = city.name;
                else this.ticketsPrintData.to_city = '';
              }

              this.goToPrintTicket(this.ticketsPrintData);
            },
            goToPrintTicket(printData) {
                let route = this.$router.resolve({ name: 'FreightPrintTicket', query: { data: JSON.stringify(printData)}});
                let url = route.href;
                let newWindow = window.open(url, '_blank', 'height=720,width=1280');
            },
            getCity(id) {
                return this.$store.dispatch('storekeepers_stocks/getCity', id);
            },
            getFreight(id) {
                this.form.id = id;
                return this.$store.dispatch('storekeepers_stocks/getFreight', id);
            },
            setDefaultFromStock() {
              if (!this.user || this.$route.params.id !== 'new') return;
              let stock = this.user.stock.find((item, i) => i === 0);
              if (stock && stock.id) {
                this.$set(this.form, 'from_stock_id', stock.id);
                this.$set(this.form, 'from_city_id', stock.city_id);
              } else {
                this.canAcceptFreights = false;
                this.$store.commit('showSnackbar', ['Вы не прикрепленны к сладу. Чтобы принимать грузы необходимо иметь прикреплённый склад.', 6000, 'error']);
              }
            },
            setDefaultStatus() {
                if (!this.statuses || !this.statuses.length || this.$route.params.id !== 'new') return;
                let status = this.statuses.find(item => item.type == 'accepted');
                if (status) this.$set(this.form, 'status_id', status.id);
            },
            setConfirmedStatus() {
                if (!this.statuses || !this.statuses.length) return;
                let status = this.statuses.find(item => item.type == 'confirmed');
                if (status) this.$set(this.form, 'status_id', status.id);
            },
            setDefaultIssueStatus() {
              if (!this.freightsStatuses || !this.freightsStatuses.length) return;
              let status = this.freightsStatuses.find((item, i) => item.code === 'storekeeper_issued_to_client');
              this.issueStatus = Object.assign({}, status);
              return status;
            },
            setDefaultTrackingStatus() {
                if (!this.freightsStatuses || !this.freightsStatuses.length) return 0;
                let status = this.freightsStatuses.find((item, i) => item.code === 'storekeeper_accepted_from_client');
                if (status) this.$set(this.form, 'freight_status_id', status.id);
                return status;
            },
            setDefaultExecutor() {
              if (!this.companies || !this.companies.length || this.$route.params.id !== 'new') return;
              let company = this.companies.find((item, i) => !!parseInt(item.is_default) && !!parseInt(item.active));
              this.$set(this.form, 'executor_company_id', company.id);
            },
            setDefaultPaymentMethod() {
              if (!this.paymentMethods || !this.paymentMethods.length || this.$route.params.id !== 'new') return;
              let method = this.paymentMethods.find((item, i) => parseInt(item.type) === 2);
              this.$set(this.form, 'payment_method_id', method.id);
            },
            /**
             * Получение складов, к которым привязан текущий пользователь
             */
            getStorekeepersStocks() {
                if (!this.user || !this.user.id) return;
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('storekeepers_stocks/getStorekeepersStocks', {
                    filter: {model: [], relation: [['responsibles', 'id', '=', this.user.id]]}
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            getStocks() {
                return this.$store.dispatch('stock/getStocks');
            },
            suggestAddress(string) {
                return this.$store.dispatch('deals/suggest', { string: string }).then(r => {
                    if (!r) return [];
                    if (r instanceof Array) return r;
                    else {
                        let response = [];
                        response.push(r);
                        return response;
                    }
                });
            },
            selectAddress(value, item) {
              if (!this.addressTypes || !this.addressTypes.length) return;
              let type = this.addressTypes.find(item => item.code === 'order');
              if (!item.id || item.id === 'new') {
                  this.form.to_address.type_id = type.id;
                  this.form.to_address.id = null;
                  this.deal.to_address_id = 'new';
              } else this.deal.to_address_id = item.id;
            },
            clearAddress() {
              this.form.to_address_id = null;
              this.form.to_address = Object.assign({}, this.address_default);
            },
            clearStock() {
              this.form.to_stock_id = null;
            },
            getAddressTypes() {
              return this.$store.dispatch('address/getAddressTypes');
            },
            getStatuses() {
                if (this.statuses && this.statuses.length) return new Promise(resolve => resolve(this.statuses));
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('storekeepers_stocks/getStatuses').finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            getTrackingStatuses() {
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('storekeepers_stocks/getTrackingStatuses', {
                    filter: {
                        model: [
                            ['code', '=', 'storekeeper_accepted_from_client'], 'or',
                            ['code', '=', 'storekeeper_issued_to_client']
                        ]
                    }
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            getCities(searchString) {
              if (searchString && searchString.length >= 3) return this.$store.dispatch('stock/getCities', { name: searchString })
            },
            getCompanies() {
              if (!this.companies || !this.companies.length)
                  return this.$store.dispatch('companies/getCompanies');
              else return new Promise((resolve) => resolve([]));
            },
            saveTest() {
              this.$validator.validateAll().then(valid => {
                if (!valid) return;
                if (this.form.deal_id) this.saveFreight().then(freight => {
                  this.getFreight(freight.id)
                  this.$root.$emit('reload-table', 'storekeepers-freights-table')
                });
                else this.addDeal().then(deal => {
                    if (!deal || !deal.id) return;
                    if (this.form.storekeeper_comment) this.saveComment(deal.id);
                    this.saveFreight().then(freight => this.saveTracking().then(() => {
                        this.printDoc(freight.deal_id, 'stock_note');
                        this.$root.$emit('reload-table', 'storekeepers-freights-table');
                        this.$router.push({name: this.$route.name, params: {id: freight.id}});
                      })
                    );
                });
              });
            },


            validate() {
              let ValidPromises = [];
              ValidPromises.push(this.$validator.validateAll());
              if (this.freight.id && this.$route.params.id != 'new') ValidPromises.push(this.$refs.freightCard.validate());

              return Promise.all(ValidPromises).then(arr => {
                return !(arr.indexOf(false)+1);
              });
            },
            async save() {
                if (this.loading) return;
                //this.saveTest(); return;
                this.validate().then(async valid => { 
                    if (!valid) return;
                      //если груз или заявка уже созданны, то создаем только отметку
                      if (this.form.id && this.form.id != 'new') {
                          //Если у заявки уже есть подпись, значит этот груз принял экспедитор, и можно взять подписи из сущности заявки
                          if (this.deal.from_signature)       this.freight.from_signature = this.deal.from_signature;
                          if (this.deal.from_stock_signature) this.freight.from_stock_signature = this.deal.from_stock_signature;

                          //если нет подписи, то сохраняем после неё, если есть, то сразу сохраняем
                          if (!this.freight.from_stock_signature) {
                              this.capture().then(() => {
                                  //если заявка уже есть, то сохраняем только груз, если нет, то сохраняем все сущности
                                  if (this.form.deal_id) this.saveFreight().then(freight => {
                                      //this.print({name: 'FreightPrintStockNote'}); //старый метод
                                      if (freight) this.printDoc(freight.deal_id, 'stock_note');
                                      else this.$store.commit('showSnackbar', ['Ошибка печати складской записки', 6000, 'success']);

                                      this.$root.$emit('reload-table', 'storekeepers-freights-table');
                                      this.$router.push({name: this.$route.name, params: {id: freight.id}});
                                    });
                                  else this.addDeal().then(deal => {
                                      this.saveComment(deal.id);
                                      this.saveFreight().then(freight => {
                                          //this.print({name: 'FreightPrintStockNote'}); //старый метод
                                          if (freight) this.printDoc(freight.deal_id, 'stock_note');
                                          else this.$store.commit('showSnackbar', ['Ошибка печати складской записки.', 6000, 'success']);

                                          this.$root.$emit('reload-table', 'storekeepers-freights-table');
                                          this.$router.push({name: this.$route.name, params: {id: freight.id}});
                                      })
                                  });
                                  this.$store.commit('showSnackbar', ['Заявка и груз успешно подписаны', 6000, 'success']);
                              }, () => alert('Ошибка подписи'));
                          } else {
                              if (this.form.deal_id) this.saveFreight().then(freight => {
                                if (freight) this.printDoc(freight.deal_id, 'stock_note');
                                else this.$store.commit('showSnackbar', ['Ошибка печати складской записки .', 6000, 'success']);

                                this.$root.$emit('reload-table', 'storekeepers-freights-table');
                                this.$router.push({name: this.$route.name, params: {id: freight.id}});
                              });
                              else this.addDeal().then(deal => {
                                  this.saveComment(deal.id);
                                  this.saveFreight().then(freight => {
                                    if (freight) this.printDoc(freight.deal_id, 'stock_note');
                                    else this.$store.commit('showSnackbar', ['Ошибка печати складской записки..', 6000, 'success']);
                                    
                                    this.$root.$emit('reload-table', 'storekeepers-freights-table');
                                    this.$router.push({name: this.$route.name, params: {id: freight.id}});
                                  });
                              });
                          }
                      } else {
                        if (this.form.deal_id) {
                          let freight = await this.saveFreight();
                          if (!freight || !freight.id) return;
                          this.saveTracking().then(() => {
                            this.$root.$emit('reload-table', 'storekeepers-freights-table');
                            this.$router.push({name: this.$route.name, params: {id: freight.id}, query: {
                                print_tickets: true,
                                sender: this.form.sender_comment,
                                recipient: this.form.recipient_comment,
                              }});
                          });
                        } else {
                          //Если доставка до адреса, то сохраняем его
                          if (parseInt(this.form.delivery_method_to) === 2) {
                            let address = await this.addAddress(this.form.to_address);
                            if (!address || !address.id) return;

                            //Добавляем адрес к заявке
                            this.form.to_address.id = address.id;
                            this.form.to_address_id = address.id;
                            if (address.city_id) this.form.to_city_id = address.city_id;
                          }

                          let deal = await this.addDeal();
                          if (!deal || !deal.id) return;
                          
                          let freight = await this.saveFreight();
                          if (!freight || !freight.id) return;
                          
                          this.saveComment(deal.id);
                          this.saveTracking().then(() => {
                            this.$root.$emit('reload-table', 'storekeepers-freights-table');
                            this.$router.push({name: this.$route.name, params: {id: freight.id}, query: {
                              print_tickets: true,
                              sender: this.form.sender_comment,
                              recipient: this.form.recipient_comment,
                            }});
                          });
                        }
                      }
                });
            },
            addDeal() {
                this.loading = true;
                let data = {
                    sort:           100,
                    description:    '',
                    status_id:      this.form.status_id,
                    responsible_id: null,
                    
                    from_city_id:   this.form.from_city_id,
                    from_stock_id:  this.form.from_stock_id,

                    to_city_id:     this.form.to_city_id,
                    to_stock_id:    this.form.to_stock_id,
                    to_address_id:  this.form.to_address_id,
                    
                    executor_company_id: this.form.executor_company_id,
                    delivery_method_from: 1,
                    delivery_method_to: parseInt(this.form.delivery_method_to),
                    payment_method_id: this.form.payment_method_id,
                    status_issue_id: 1,
                    status_issue_type_id: 1,
                };
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('storekeepers_stocks/saveDeal', data).then(r => {
                    if (r) this.form.deal_id = r.id;
                    this.loading = false;
                    this.$store.commit('showSnackbar', ['Заявка успешно сохранена', 6000, 'success']);
                    return r;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            saveFreight() {
                this.loading = true;
                return (this.form.id) ? this.updateFreight() : this.addFreight();
            },
            addFreight() {
                let data = {
                    deal_id: this.form.deal_id,
                    seats_number: this.form.seats_number,
                    departure_date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                    size_units: 'm',
                    storekeeper_comment: this.form.storekeeper_comment
                };
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('storekeepers_stocks/saveBlankFreight', data).then(async r => {
                    if (r) {
                      this.form.id = r.id;
                      this.freight.id = r.id;
                      await this.$refs['packageservices'].saveValues(r.id);
                    }
                    this.loading = false;
                    this.$store.commit('showSnackbar', ['Груз успешно добавлен', 6000, 'success']);
                    return r;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            updateFreight() {
                //ключ "not_update_price" позволяет сохранять/обновлять груз не пересчитывая цену
                //тут это надо так как в этот момент у заявки еще не указан плательщик, а значит посчитать цену мы не можем
                this.freight.not_update_price = true;
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('storekeepers_stocks/updateFreight', this.freight).then(async r => {
                    //сохранение услуг груза
                    await this.$refs['packageservices'].saveValues(this.$route.params.id);
                    this.loading = false;
                    this.$store.commit('showSnackbar', ['Груз успешно обновлён', 6000, 'success']);
                    return r;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            saveTracking() {
                let data = {
                    freight_id: this.form.id,
                    status_id:  this.form.freight_status_id,
                    stock_id:   this.form.from_stock_id,
                    responsible_id: this.user.id,
                    date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                };
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('stock/addFreightTracking', data).then(r => {
                    this.$store.commit('showSnackbar', ['Трекинговая отметка успешно сохранена', 6000, 'success']);
                    return r;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card'));
            },
            addAddress(address) {
              //this.$store.commit('showProgressBar', 'load-customer-card');
              return this.$store.dispatch('address/postAddress', address).then(address => {
                if (!address || !address.id) return;
                this.form.to_address.id = address.id;
                this.form.to_address_id = address.id;
                if (address.city_id) this.form.to_city_id = address.city_id;
                return address;
              }).catch(e => {
                this.$store.commit('showSnackbar', ['Ошибка добавления адреса' + (e.message ? ': ' + e.message : '.'), 6000, 'error'])
                return;
              })//.finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            changeFreight(newFreight) {
                if (!(JSON.stringify(newFreight) === JSON.stringify(this.freight))) {
                    this.freight = Object.assign({}, newFreight);
                    if (parseInt(this.freight.weight) <= 0) this.freight.weight = null;
                    if (parseInt(this.freight.size)   <= 0) this.freight.size = null;
                }
            },
            saveComment(dealId) {
              let comment = '<div class="storekeeper-comment">' +
                ('Отправитель: ' + (this.form.sender_comment ? this.form.sender_comment : 'не указан') + '<br>') +
                ('Получатель: '  + (this.form.recipient_comment ? this.form.recipient_comment : 'не указан') + '<br>') +
                ('Отправление: ' + (this.form.from_city ? this.form.from_city : 'не указан') + '<br>') +
                ('Назначение: '  + (this.form.to_city ? this.form.to_city : 'не указан') + '<br>') +
                (this.form.storekeeper_comment ? this.form.storekeeper_comment : '' ) + '</div>';

              this.loading = true;
              return this.$store.dispatch('comments/addComment', {
                  comment: {
                      module_code: 'deals', entity: 'deals',
                      entity_id: dealId, text: comment
                  }
              }).then(() => this.$store.commit('showSnackbar', ['Комментарий кладовщика добавлен', 6000, 'success'])).finally(() => this.loading = false);
            },
            saveCommentStorekeeper(dealId) {
                this.loading = true;
                return this.$store.dispatch('comments/addComment', {
                    comment: {
                        module_code: 'deals', entity: 'deals',
                        entity_id: dealId, text: this.form.storekeeper_comment
                    }
                }).then(() => this.$store.commit('showSnackbar', ['Комментарий кладовщика добавлен', 6000, 'success'])).finally(() => this.loading = false);
            },
            saveCommentSender(dealId) {
                this.loading = true;
                return this.$store.dispatch('comments/addComment', {
                    comment: {
                        module_code: 'deals', entity: 'deals',
                        entity_id: dealId, text: ('Отправитель: ' + this.form.sender_comment)
                    }
                }).finally(() => this.loading = false);
            },
            saveCommentRecipient(dealId) {
                this.loading = true;
                return this.$store.dispatch('comments/addComment', {
                    comment: {
                        module_code: 'deals', entity: 'deals',
                        entity_id: dealId, text: ('Получатель: ' + this.form.recipient_comment)
                    }
                }).finally(() => this.loading = false);
            },
            getPaymentMethods() {
                this.$store.dispatch('cost/getPaymentMethods', {page: 1, order_by: 'id', order_type: 'asc', count: 100, filter: {model: [['active', '=', 1]]}});
            },
            getPayersServices() {
              if (!this.payersServices) this.$store.dispatch('deals/getFreightPayersServices').then(services => this.payersServices = Object.assign({}, services));
            },
            preparePayerServices(services) {
                if (!this.freight.extraservices) this.freight.extraservices = {};
                if (!services || !Object.values(services).length) return;
                Object.entries(services).forEach(([key, value]) => {
                    if (!this.freight.extraservices[key]) this.freight.extraservices[key] = Object.assign({}, value)
                })
            },
            async init() {
                this.deal = Object.assign({}, {});
                this.clearPrintTicketData();
                this.getPayersServices();
                if (this.$route.params.id != 'new') {
                  this.getStatuses(),
                  await this.getFreight(this.$route.params.id);
                } else {
                    this.form = Object.assign({}, this.form_default);
                    this.freight = {};
                    this.getStatuses().then(() => this.setConfirmedStatus());
                }
                
                Promise.all([
                    this.getAddressTypes(),
                    this.getStocks(),
                    this.getCompanies(),
                    this.getTrackingStatuses(),
                    this.getStorekeepersStocks(),
                    this.getPaymentMethods()
                ]).finally(() => {
                    this.setDefaultFromStock();
                    this.setDefaultTrackingStatus();
                    this.setDefaultIssueStatus();
                    this.setDefaultExecutor();
                    this.setDefaultPaymentMethod();
                    this.checkPrintTickets();
                });


                this.$store.commit('openRightPanel');
            },
            /**
             * Проверяет надо ли печатать этикетки
             * и не был ли этот процесс уже запущен только что,
             * и запускает печать
             */
            async checkPrintTickets() {
                this.$nextTick(async () => {
                    if (
                        !this.isLoading && this.freight && this.freight.id && this.freight.traking_number && 
                        this.$route.query && this.$route.query.print_tickets && !this.alreadyPrint
                    ) {
                      this.alreadyPrint = true;
                      await this.getPrintTicketData();
                      setTimeout(() => {
                        //this.printTicket();
                          if (this.$refs && this.$refs.TicketsPrint) this.$refs.TicketsPrint.print();
                      }, 1000);
                    }
                });
            },

            getPrintCity() {
              let Promises = [];
              if (this.form.from_city_id) Promises.push(this.getCity(this.form.from_city_id).then(city => {
                  if (!city) return null;
                  this.form.from_city = city.name;
                  this.ticketsPrintData.fromCity = city.name;
                  return city;
              }));
          
              if (this.form.to_city_id) Promises.push(this.getCity(this.form.to_city_id).then(city => {
                if (!city) return null;
                this.form.to_city = city.name;
                this.ticketsPrintData.toCity = city.name;
                return city;
              }));

              if (!Promises || !Promises.length) return new Promise(resolve => resolve());
              else return Promise.all(Promises);
            },
            clearPrintTicketData() {
              Object.keys(this.ticketsPrintData).map(key => {
                this.ticketsPrintData[key] = null;
              });
            },
            async getPrintTicketData() {
              return new Promise(async resolve => {
                await this.getPrintCity();
                
                this.ticketsPrintData.trackingNumber = this.freight.traking_number;
                this.ticketsPrintData.date           = (this.freight.acceptedtracking && this.freight.acceptedtracking.date) ? moment(this.freight.acceptedtracking.date).format('DD.MM.YYYY') : null;
                if (!this.ticketsPrintData.date) this.ticketsPrintData.date = (this.freight.created_at) ? moment(this.freight.created_at).format('DD.MM.YYYY') : null;
                this.ticketsPrintData.fromCity       = this.form.from_city;
                this.ticketsPrintData.toCity         = this.form.to_city;

                this.ticketsPrintData.sender    = (this.$route.query.sender    ? this.$route.query.sender    : '');
                this.ticketsPrintData.recipient = (this.$route.query.recipient ? this.$route.query.recipient : '');
                
                if (this.freight.deal && this.freight.deal.recipient && this.freight.deal.recipient.id && this.freight.deal.recipient.name) this.ticketsPrintData.recipient = this.freight.deal.recipient.name;
                if (this.freight.deal && this.freight.deal.sender    && this.freight.deal.sender.id    && this.freight.deal.sender.name)    this.ticketsPrintData.sender    = this.freight.deal.sender.name;

                this.ticketsPrintData.tempReg = (this.freight) ? this.HasTempReg(this.freight) : false;

                resolve(this.ticketsPrintData);
              });
            },
            HasTempReg(freight) {
                if (!freight || !freight.services || !Array.isArray(freight.services) || !freight.services.length) return false;
                return !!freight.services.find(item => parseInt(item.id) === 22);
            },
        },
        created() {
            this.$nextTick(() => {
                this.$root.isAuth().then(
                    () => this.init(),
                    () => this.$router.push({name: 'Login'})
                );
            });
            this.$store.commit('adaptiveSizePanel');

            this.$root.$on('update-freight-form', (id) => {
              if (id && parseInt(id) === parseInt(this.$route.params.id)) this.init();
            });
        }
    }
</script>
<style lang="sass">
  #freights
    .delivery
      .md-layout-item
        margin: 0 5px
        width: calc(50% - 10px)
        min-width: calc(50% - 10px)
        flex: auto
    .shipment
      .deny
        color: #d66565
    .full_oversize
      font-size: 12px
      line-height: 14px
    .entity-card-footer
      justify-content: flex-start
</style>
 


// WEBPACK FOOTER //
// Freight.vue?5b478b6a